import { useMutation } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import {
  RequestFinanceEntryResponse,
  UpdateFinanceEntryRequestDTO,
} from "@/types";
import { httpRequest } from "@/lib/axios";

async function updateFinanceEntry(
  request: UpdateFinanceEntryRequestDTO
): Promise<RequestFinanceEntryResponse> {
  const { id, ...data } = request;
  const response = await httpRequest.put<RequestFinanceEntryResponse>(
    `/finance-entries/${id}`,
    data
  );
  return response.data;
}

export function useUpdateFinanceEntryMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateFinanceEntry,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["finance-entries"] });
    },
  });
}
